import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Rating } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { FaTruck } from "react-icons/fa";
import { GiThermometerScale } from "react-icons/gi";
import { SlCalender } from "react-icons/sl";

export const ShopInfoAccordian = ({ product }) => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  return (
    <div>
      <ul className="flex mt-3 mb-5 title-in-shoppage flex-wrap justify-center md:justify-normal">
        <li className="uppercase tracking-widest text-xs">
          <Link to="/">Home</Link>
        </li>
        <li className="dot-breadcrumb uppercase tracking-widest text-xs">
          <Link to="/category">Product</Link>
        </li>
        <li className="dot-breadcrumb uppercase tracking-widest text-xs">
          {product[0]?.prdname}
        </li>
      </ul>
      <div className="shopaccordion" style={{ margin: "0 auto" }}>
        <div>
          <div>
            <p className="mb-2 mt-2 text-slate-500 text-3xl font-medium">
              {product[0]?.prdname}
            </p>
            <p className="mb-3 tracking-wider text-gray-800">
              <span className="my-2 font-semibold">
                Price : Price on Request
              </span>
              <p className="text-sm tracking-wider">
                *The price of this item will vary based on grammage and the gold
                rate on that particular day. Call us
              </p>
              <a href="tel:+18475555555" className="underline">
                +1-847-555-5555
              </a>
            </p>
          </div>
          <div className="flex mb-3 justify-center align-center rating">
            <div>
              {product[0]?.rating ? (
                <Rating
                  name="read-only"
                  value={product[0]?.rating}
                  size="small"
                  className="mt-1"
                />
              ) : (
                <span></span>
              )}
            </div>
            <p className="ms-2 text-md text-slate-500">reviews</p>
          </div>
        </div>

        <div className="my-5">
          <p className="flex justify-center mr-2">
            <span className="text-lg">
              <FaTruck />
            </span>
            <span className="uppercase text-xs font-medium ms-2 tracking-wider">
              Delivery & Return
            </span>
          </p>
          <p className="flex justify-center mr-2 my-3">
            <span className="text-lg">
              <GiThermometerScale />
            </span>
            <span className="uppercase text-xs font-medium ms-2 tracking-wider">
              Size
            </span>
          </p>
          <p className="flex justify-center mr-2">
            <span className="text-lg">
              <SlCalender />
            </span>
            <span className="uppercase text-xs font-medium ms-2 tracking-wider">
              Estimated Delivery: 1 week
            </span>
          </p>
        </div>
        <div>
          <Accordion
            expanded={open === 1}
            onChange={() => handleOpen(1)}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="text-black tracking-wider text-lg"
            >
              Description
            </AccordionSummary>
            <AccordionDetails>
              <p>{product[0]?.desc}</p>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={open === 2}
            onChange={() => handleOpen(2)}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
              className="text-black tracking-wider text-lg"
            >
              Additional Information
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                        Weight
                      </th>
                      <td className="text-gray-500 ms-5">1 kg</td>
                    </tr>
                    <tr className="py-5">
                      <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                        Dimensions
                      </th>
                      <td className="text-gray-500">10 × 11 × 22 cm</td>
                    </tr>
                    <tr>
                      <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                        Color
                      </th>
                      <td>
                        {product[0]?.jwelleryColour} (Colour was customization)
                      </td>
                    </tr>
                    <tr className="my-2">
                      <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                        Sizes
                      </th>
                      <td>10K, 18K, 22K, 24K</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={open === 3}
            onChange={() => handleOpen(3)}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3a-content"
              id="panel3a-header"
              className="text-black tracking-wider text-lg"
            >
              Review
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <div className="text-center text-lg text-gray-600">
                  5 reviews for {product[0]?.prdname}
                </div>
                <div className="rating-box-main1">
                  <div className="ratingbox-1-1 bg-gray-100 py-2">
                    <div className="text-5xl font-semibold  ">5.0</div>
                    <div>
                      {product[0]?.rating ? (
                        <span>
                          <Rating
                            name="read-only"
                            value={product[0]?.rating}
                            size="small"
                            className="mt-1"
                          />
                        </span>
                      ) : (
                        <span>
                          <Rating
                            name="read-only"
                            size="small"
                            className="mt-1"
                          />
                        </span>
                      )}
                    </div>
                    <div className="text-gray-600">Based on 5 reviews</div>
                  </div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={open === 4}
            onChange={() => handleOpen(4)}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel4a-content"
              id="panel4a-header"
              className="text-black tracking-wider text-lg"
            >
              Information
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <div>
                  <p>
                    <span className="uppercase text-base font-semibold tracking-wide ms-2 text-gray-600">
                      Tags
                    </span>
                    :
                    <span className="text-black text-sm tracking-wider font-semibold">
                      Bestseller, Trend
                    </span>
                  </p>
                  <p className="my-3">
                    <span className="uppercase text-base font-semibold tracking-wide ms-2 text-gray-600">
                      Jewellery Material
                    </span>
                    :
                    <span className="text-black text-sm tracking-wider font-semibold">
                      {product[0]?.jwelleryMaterial}
                    </span>
                  </p>
                  <p>
                    <span className="uppercase text-base font-semibold tracking-wide ms-2 text-gray-600">
                      Jewellery Color
                    </span>
                    :
                    <span className="text-black text-sm tracking-wider font-semibold">
                      {product[0]?.jwelleryColour}
                    </span>
                  </p>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={open === 5}
            onChange={() => handleOpen(5)}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel5a-content"
              id="panel5a-header"
              className="text-black tracking-wider text-lg"
            >
              Q & A
            </AccordionSummary>
            <AccordionDetails>
              <div className="flex mt-5">
                <p className="border w-10/12 flex">
                  <input
                    type="text"
                    placeholder="Search Answers"
                    className="w-full"
                  />
                </p>
                <span className="rounded-none ms-4 px-10 bg-black text-white">
                  Ask a question
                </span>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};
